var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { nullStream } from "../streams";
/**
 * Standard Logger implementation. Use the global `logger` instance instead of
 * instantiating this directly.
 */
export class LoggerImpl {
    debug(context, errorOrMessage, message) {
        this.log("debug", context, errorOrMessage, message);
    }
    info(context, errorOrMessage, message) {
        this.log("info", context, errorOrMessage, message);
    }
    warn(context, errorOrMessage, message) {
        this.log("warn", context, errorOrMessage, message);
    }
    error(context, errorOrMessage, message) {
        this.log("error", context, errorOrMessage, message);
    }
    log(level, context, errorOrMessage, message) {
        let event;
        try {
            event = LoggerImpl.getLogEvent(level, context, errorOrMessage, message);
        }
        catch (err) {
            // Log to console, as this should be visible in Datadog, Fullstory, etc.
            console.error("logging error", err, { level, context, errorOrMessage, message });
            return;
        }
        try {
            LoggerImpl.stream(event);
        }
        catch (err) {
            // Log to console, as this should be visible in Datadog, Fullstory, etc.
            console.error("logging error", err, event);
        }
    }
    static getLogEvent(level, _a, errorOrMessage, possibleMessage) {
        var { error: contextError, err: contextErr } = _a, partialContext = __rest(_a, ["error", "err"]);
        const error = LoggerImpl.getError(contextError, contextErr, errorOrMessage, possibleMessage);
        const context = LoggerImpl.getContext(partialContext);
        const message = LoggerImpl.getMessage(context, error, errorOrMessage, possibleMessage);
        return {
            level,
            message,
            error,
            context,
        };
    }
    static getError(contextError, contextErr, errorOrMessage, possibleMessage) {
        const errorFromArgs = LoggerImpl.getErrorFromArgs(errorOrMessage, possibleMessage);
        const errorFromContext = LoggerImpl.getErrorFromContext(contextError, contextErr);
        return errorFromArgs !== null && errorFromArgs !== void 0 ? errorFromArgs : errorFromContext;
    }
    static getErrorFromArgs(errorOrMessage, possibleMessage) {
        if (errorOrMessage instanceof Error) {
            return errorOrMessage;
        }
        else if (possibleMessage) {
            // In this case, we're using the logging overload where errorOrMessage is an error, but
            // errorOrMessage is not an instance of Error, so we create an error using this message.
            return new Error(String(errorOrMessage));
        }
        else {
            return undefined;
        }
    }
    static getErrorFromContext(contextError, contextErr) {
        const errorPropertyFromContext = contextError !== null && contextError !== void 0 ? contextError : contextErr;
        if (errorPropertyFromContext instanceof Error) {
            return errorPropertyFromContext;
        }
        else if (errorPropertyFromContext) {
            return new Error(String(errorPropertyFromContext));
        }
        else {
            return undefined;
        }
    }
    static getContext(partialContext) {
        return Object.assign(Object.assign({}, LoggerImpl.globalContext), partialContext);
    }
    static getMessage(context, error, errorOrMessage, possibleMessage) {
        if (possibleMessage) {
            return possibleMessage;
        }
        else if (!(errorOrMessage instanceof Error)) {
            return String(errorOrMessage);
        }
        else if (error) {
            return error.message || (context.fn ? `error during ${context.fn}` : "error");
        }
        else {
            return "error";
        }
    }
}
LoggerImpl.stream = nullStream;
LoggerImpl.globalContext = {};
//# sourceMappingURL=LoggerImpl.js.map